<template>
  <modal :show.sync="modals.modal1" footerClasses="text-right" :largeModal="true">
    <h6
      slot="header"
      class="modal-title text-success font-weight-bold"
      id="modal-title-default"
    >{{title}}</h6>
    <div class="d-block">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form ref="form" @submit.stop.prevent="handleSubmit(getData)">
          <p class="description">* Silahkan masukan NOP yang ingin dicari objek pajak nya.</p>
          <div class="mb-5">
            <div class="row">
              <div class="col-lg-4 col-sm-6">
                <ValidationProvider name="NOP" rules="required" v-slot="{ errors }">
                  <base-input
                    placeholder="NOP"
                    v-model="form.nop"
                    :required="true"
                    :error="errors[0]"
                    :valid="(errors[0] !== null && errors[0] !== '')"
                  ></base-input>
                </ValidationProvider>
              </div>
              <div class="col-lg-4 col-sm-6">
                <base-button type="success" nativeType="submit" :disabled="isBusy" icon="ni ni-zoom-split-in">Cari Data</base-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
      <hr />
      <b-table
        :bordered="true"
        :small="true"
        :hover="true"
        :items="items"
        :fields="fields"
        :head-variant="'light'"
        :busy.sync="isBusy"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <pulse-loader :loading="isBusy" :color="'#d7f6e8'"></pulse-loader>
            <strong>Loading...</strong>
          </div>
        </template>
      </b-table>
    </div>
    <template slot="footer">
      <base-button type="warning" @click="modals.modal1 = false">Tutup</base-button>
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import { BTable, BTr, BTh } from "bootstrap-vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import Swal from "sweetalert2";
import axios from "@/plugins/axios";
import dateToDateHumanize from "@/plugins/dateFormater";
import formatToMoney from "@/plugins/formatToMoney";
import mapInvestigationType from "@/plugins/mapInvestigationType";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  components: {
    Modal,
    BTable,
    PulseLoader,
    BTr,
    BTh,
    ValidationProvider,
    ValidationObserver
  },
  props: {
    title: {
      type: String,
      description: "Judul Modal"
    },
    code: {
      type: String,
      description: "Code Pajak"
    },
    url: {
      type: String,
      description: "Url Pajak"
    }
  },
  data() {
    return {
      modals: {
        modal1: false
      },
      form: {
        nop: null
      },
      fields: [
        {
          key: "thnPajakSppt",
          sortable: false,
          label: "Tahun Pajak",
          class: "text-center",
          thClass: "text-center"
        },
        {
          key: "namaWp",
          sortable: false,
          label: "Nama Wajib Pajak",
          class: "text-center",
          thClass: "text-center"
        },
        {
          key: "alamatWp",
          sortable: false,
          label: "Alamat Wajib Pajak",
          class: "text-center",
          thClass: "text-center"
        },
        {
          key: "pbbYgHarusDibayarSppt",
          sortable: false,
          label: "Tagihan PBB",
          class: "text-right",
          thClass: "text-center",
          formatter: function(value) {
            return formatToMoney(value);
          }
        },
        {
          key: "dendaSppt",
          sortable: false,
          label: "Denda",
          class: "text-right",
          thClass: "text-center",
          formatter: function(value) {
            return formatToMoney(value);
          }
        },
        {
          key: "jmlSpptYgDibayar",
          sortable: false,
          label: "Jumlah Bayar",
          class: "text-right",
          thClass: "text-center",
          formatter: function(value) {
            return formatToMoney(value);
          }
        },
        {
          key: "statusPembayaranSppt",
          sortable: false,
          label: "Status",
          class: "text-center",
          thClass: "text-center"
        }
      ],
      items: [],
      isBusy: false
    };
  },
  methods: {
    showModal() {
      this.items = [];
      this.form.nop = "";
      this.modals.modal1 = true;
    },
    hideModal() {
      this.modals.modal1 = false;
    },   
    async getData() {
      try {
      
        this.isBusy = true;       
        let { data }  = await axios.get(this.url +""+this.form.nop);
       
        this.items = !(data.data) ? [] : data.data;
      } catch (error) {
        Swal.fire({
          title: "",
          text: error.message,
          type: "warning",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Tutup!"
        });
         this.isBusy = false;
      } finally {
        this.isBusy = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.modal-dialog {
  max-width: 80% !important;
  margin: 1.75rem auto;
}
</style>